export default "__VITE_ASSET__BNYEvCb7__"